import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Spinner from '@components/molecules/Spinner';
import { useQuery } from '@tanstack/react-query';
import { PRODUCT_KEYS } from '@src/types/productType';
import { CallGetOptGroupProducts, CallPutOptUnlick } from '@library/request/callProduct';
import { useMenuPermission } from '@src/recoil/permission';

const OptionUnconnect = () => {
  const [searchParams] = useSearchParams();

  const storeId = searchParams.get('storeID');
  const optionGroupID = searchParams.get('optionGroupID');

  const { isNoAuth8 } = useMenuPermission(storeId);

  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);

  const { data: optGroup, refetch } = useQuery([PRODUCT_KEYS.OPTIONGROUP, storeId, optionGroupID], {
    enabled: true,
    queryFn: async () => {
      try {
        setLoading(true);
        const res = await CallGetOptGroupProducts(storeId, optionGroupID);
        if (res.data) {
          setProducts(res.data as any);
        }

        return res.data as any;
      } catch (error) {
        console.log('error', error);
        throw error;
      } finally {
        setLoading(false);
      }
    },
  });

  const unconnectAll = async () => {
    if (isNoAuth8) return;
    if (!window.confirm('해당 옵션과 연결된 메뉴를 모두 해제하시겠습니까?')) return;
    setLoading(true);
    try {
      const res = await CallPutOptUnlick(storeId, optionGroupID);
      if (res.result.code === 1) {
        window.history.back();
      }
    } catch (error) {
      console.log('error', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <article id="mArticle" className="art-product menu-sortable-list">
      <div className="view-sort">
        <div className="box-product">
          <strong id="title" className="lab-product">
            연결 메뉴
          </strong>
          <p className="desc-product">해당 옵션과 현재 연결되어 있는 메뉴입니다.</p>
          <div className={`area-product ${products.length === 0 ? 'empty' : ''}`}>
            {products.length === 0 ? '연결된 메뉴가 없습니다.' : products.map((v) => v.productName).join(',')}
          </div>
        </div>
      </div>
      <div className={`fixedBtnGroup ${products.length === 0 ? 'none' : ''}`}>
        <button type="button" id="btnSubmit" className="btnDone" onClick={unconnectAll} disabled={isNoAuth8}>
          연결 메뉴 모두 해제
        </button>
      </div>
      <Spinner show={loading} />
    </article>
  );
};

export default OptionUnconnect;
